import { useQuery } from 'react-query';
import ItemServiceApi from '../../Api/item-service';
import { ItemPhoto } from './types';

export type UseGetItemPhotoURLsRawResponse = {
  photos: ItemPhoto[];
};

export type UseGetItemPhotoURLsReturnResponse = {
  photos: ItemPhoto[];
  product_photo?: ItemPhoto;
  front_photo?: ItemPhoto;
  swatch_photo?: ItemPhoto;
  fit_photos: ItemPhoto[];
  gallery_photos: ItemPhoto[];
};

export const useGetItemPhotoURLs = (userId: string, itemId: string) =>
  useQuery<
    UseGetItemPhotoURLsRawResponse,
    Error,
    UseGetItemPhotoURLsReturnResponse
  >(
    ['item-service-photo-urls', userId, itemId],
    () => ItemServiceApi.getItemPhotoURLs(userId, itemId),
    {
      select: (data) => {
        const fitPhotos = data.photos.filter((p) => p.type === 'fit');
        const frontPhoto = data.photos.find((p) => p.type === 'front');
        const swatchPhoto = data.photos.find((p) => p.type === 'swatch');
        const galleryPhotos = data.photos.filter((p) => p.type !== 'swatch');
        return {
          photos: data.photos,
          product_photo: fitPhotos?.[0] ?? frontPhoto ?? undefined,
          front_photo: frontPhoto,
          swatch_photo: swatchPhoto,
          fit_photos: fitPhotos,
          gallery_photos: galleryPhotos,
        };
      },
      staleTime: 300_000, // 5 minutes
    },
  );
